// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 4,
  scroll: 4,
});

// new Swiper("#swiper-btn", {
//   autoplay: true,
//   autoplay: {
//     disableOnInteraction: false,
//     // delay: 5000,
//   },
//   loop: true,
//   spaceBetween: 30,
// });

// let spImgList = [];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            246 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();
let colorList = window.options[0].values
let spImgList = [
  [
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/ptingf1.png',
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/ptingf4.png',
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/ptingf3.png',
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/ptingf2.png',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240816-p2-1.png',
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240816-p2-2.png',
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240816-p2-3.png',
    'https://cdn.shopify.com/s/files/1/0706/5246/1375/files/20240816-p2-4.png'
  ]
]
let prods = window.product
function getCur(){
  let color = $('#sp-color div.active').attr('data-val')
  let style = $('#sp-style div.active').attr('data-val')
  let size = $('#sp-num div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == style && item.option3 == size)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price * num / 100).toFixed(2)
  let compare = (getCur().compare_at_price * num / 100).toFixed(2)
  // if(num == 1){
  //   price = (getCur().price * num / 100).toFixed(2)
  // }else if(num == 2){
  //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
  // }else if(num == 3){
  //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
  // }else {
  //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
  // }
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .brand .num").html(off_font);

  let index1 = $('#sp-num div.active').index()
  let index2 = $('#sp-color div.active').index()
  $('.product-part .sp-relative img').attr('src', spImgList[index1][index2])
  if(index2 == 3){
    $('.product-part .sp-colot-text').css('color', '#000')
    $('.product-part .sp-colot-text').html('white')
  }else{
    $('.product-part .sp-colot-text').css('color', '#fff')
      $('#spColor').html(colorList[index2])
  }

}
function showTip() {
  let result = Number(($("#sp_price1").html()).replace(',', '.'))
  if (result >= 500) {
    $("#freeBtn").addClass("sp-free-btn");
  } else {
    $("#freeBtn").removeClass("sp-free-btn");
  }
}
$(".option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  changePrice()
});
$(".reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let number = Number(input.value) - 1;
  if (number > 0) {
    input.value = number;
    changePrice()
  }  
});
$(".add").click(function () {
  let input = $(this).siblings("input")[0];
  let number = Number(input.value) + 1;
  input.value = number;
  changePrice()
});
$('#freeBtn').on('click',function(){
  let id = getCur().id
  let num = $("#calcNumber").val();
  window.location.href = '/cart/' + id + ':' + num
})
$("#add-cart").click(function () {
  // do something here
    let data = {
      id: getCur().id,
      quantity: $("#calcNumber").val()
    };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
        $("#cardNum").html(result.item_count);
        // handleAddToCart(result.item_count);
      });
    },
    dataType: "json",
  });

 var img = $('.sp-relative .p-img')
    var flyer = img[0].cloneNode(true)
    $(flyer).hide()
    flyer.classList.add('clone1')
    $('.sp-part5').append(flyer)
    $('.clone1').css({
      width: '948px',
      height: '516px',
      position: 'fixed',
      top: img[0].offsetTop,
      left: img.offset().left,
      'z-index': '99999',
      display:"block"
    })
  $(".sp-cart").addClass("shake");
  setTimeout(() => {
    $(".sp-cart").removeClass("shake");
  }, 1000);
  let finish = $(".sp-cart");
  $(".clone1").animate(
    {
      top: finish[0].offsetTop,
      left: finish[0].offsetLeft + finish.width(),
      width: 30, // 结束时的大小，根据需要调整
      height: 30, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    1000,
    "linear",
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0,
        function () {
          $(this).detach(); // 完成动画后移除克隆的图片
        }
      );
    }
  );
});

// $(".sp-opt-wrap .opt").click(function () {
//   $(this).addClass("active").siblings().removeClass("active");
//   let id = $(this).attr('data-id')
//   let price = window.product.filter(item=> item.id == id)[0].price / 100
//   let compare = window.product.filter(item=> item.id == id)[0].compare_at_price / 100
//   $(this).parent().siblings('.price-group').find('.price1 span').html(price)
//   $(this).parent().siblings('.price-group').find('.price2 span').html(compare)
//   $(this).parent().siblings('.price3').find('span').html((compare - price).toFixed(2))
// });
// $('.buyNow').click(function(){
//   let id = $(this).siblings('.sp-opt-wrap').find('div.active').attr('data-id')
//   window.location.href = '/cart/' + id + ':1'
// })

let off_font = 100 - Math.ceil(window.product[3].price / window.product[3].compare_at_price * 100)
$('.off_font').html(off_font)